<template>
  <div class="calendar">
    <full-calendar :config="config" @day-click="dayClick"></full-calendar>
  </div>
</template>

<script>
import { FullCalendar } from 'vue-full-calendar';

export default {
  name: 'Calendar',
  components: {
    FullCalendar
  },
  props: [

  ],
  data() {
    return {
      config: {
        defaultView: 'month',
        header: {
          left: 'prev',
          center: 'title',
          right: 'next'
        },
        height:500
      }
    };
  },
  methods: {
    dayClick(date) {
      let url = '/day/' + date.format('YYYY-MM-DD');
      this.$router.push(url);
    }
  },
  computed: {

  },
  created() {

  },
  watch: {

  }
};

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Calendar.vue